/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ProductInfo.vue?vue&type=template&id=454aa01f&scoped=true&"
import script from "./ProductInfo.vue?vue&type=script&lang=js&"
export * from "./ProductInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfo.vue?vue&type=style&index=0&lang=less&"
import style1 from "./ProductInfo.vue?vue&type=style&index=1&id=454aa01f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454aa01f",
  null
  
)

export default component.exports